import React from "react"
import { useStore } from "../../teafuljs/store"
import { navigate } from "gatsby"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import InputLabel from "@material-ui/core/InputLabel"
import MuiMenuItem from "@material-ui/core/MenuItem"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import KeyPassages from "../../data/newKeyPassages.json"
import GetSegment from "../../scripts/NavigateToSegment"
import scrollToElement from "scroll-to-element"
import { getTranslation } from "../../scripts/getTranslation"
import getVersionVerse from "../../scripts/getVersionVerse"
import CheckMark from '../CheckMark'

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  formControl: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    margin: theme.spacing(1),
    width: "75vw",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  checkMarkDiv: {
    height: "25px",
    width: "25px",
    paddingBottom: 5,
  },
}))

const MenuItem = withStyles({
  root: {
    flexWrap: 'no-wrap',
    justifyContent: "flex-start",
  },
})(MuiMenuItem)

export default function SimpleSelect(props) {
  const classes = useStyles()
  const [currentSphere, setCurrentSphere] = useStore.currentSphere();
  const [currentKeyPassage, setKeyPassage] = useStore.currentKeyPassage();
  const [history, setHistory] = useStore.history();
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID();
  const [searchID, setSearchID] = useStore.searchID()
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0];
  const version = useStore.version()[0];
  const translations = useStore.translations()[0]
  const versification = useStore.versification()[0]
  const [sphereValue, setSphereValue] = React.useState(
    currentSphere ? currentSphere : ""
  )
  const [keyPassageValue, setKeyPassageValue] = React.useState(
    currentKeyPassage !== "" ? currentKeyPassage : ""
  )
  const spheres = {
    FOU: getTranslation(translations, language, "UI", "menu_sphere_fou"),
    FAM: getTranslation(translations, language, "UI", "menu_sphere_fam"),
    ECO: getTranslation(translations, language, "UI", "menu_sphere_eco"),
    GOV: getTranslation(translations, language, "UI", "menu_sphere_gov"),
    REL: getTranslation(translations, language, "UI", "menu_sphere_rel"),
    EDU: getTranslation(translations, language, "UI", "menu_sphere_edu"),
    COM: getTranslation(translations, language, "UI", "menu_sphere_com"),
    CEL: getTranslation(translations, language, "UI", "menu_sphere_cel"),
  }

  function handleSphereChange(event) {
    setSphereValue(event.target.value)
    setCurrentSphere(event.target.value)
    setKeyPassage("")
  }
  function handleKeyPassageChange(event) {
    setKeyPassageValue(event.target.value)
    setKeyPassage(event.target.value)
    const newKP = `${currentSphere}-${event.target.value}`
    const versionRef = getVersionVerse(
      versification[version],
      KeyPassages[newKP].ref
    )
    const book = versionRef.substring(0, 3)
    const isAvailable =
      AvailableContent.content[language][version][book] &&
      AvailableContent.content[language][version][book]
        .segments.length > 1
        ? true
        : false
    if (isAvailable) {
      search(versionRef)
    }
  }

  function getKeyPassages(sphere) {
    let KPData = Object.values(KeyPassages).filter(p => p.spheres[0] === sphere)
    KPData = KPData.sort(function(a, b) {
      if (a.number < b.number) {
        return -1
      } else if (a.number > b.number) {
        return 1
      } else if (a.number === b.number) {
        return 0
      } else {
        return 0
      }
    })
    return KPData
  }

  function search(RefID) {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
    ...history])
    const refInfo = RefID.split("-")
    const segment = GetSegment(
      refInfo[0],
      parseInt(refInfo[1]),
      parseInt(refInfo[2])
    )
    setSearchID(RefID)
    if (props.location.pathname !== "/reader") {
      setCurrentSegmentID(segment)
      navigate("/reader")
    } else if (currentSegmentID === segment) {
      props.closeMenu()
      samePageNavigation(`ref-${RefID}`)
    } else {
      props.closeMenu()
      setCurrentSegmentID(segment)
    }
  }

  function samePageNavigation(id) {
    const element = document.querySelectorAll(`[verseref=${id}]`)[0]
    scrollToElement(element, {
      offset: -65,
      ease: "inOutCube",
      duration: 1500,
    })
    setSearchID("")
  }
  return (
    <form className={classes.root} autoComplete="off">
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="age-simple">
          {getTranslation(
            translations,
            language,
            "UI",
            "menu_sphere"
          )}
        </InputLabel>
        <Select value={sphereValue} onChange={handleSphereChange}>
          {Object.keys(spheres).map((sphere, index) => (
            <MenuItem key={index} value={sphere}>
              {spheres[sphere]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {currentSphere && (
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="age-simple">
            {getTranslation(
              translations,
              language,
              "UI",
              "menu_key_passage"
            )}
          </InputLabel>
          <Select value={keyPassageValue} onChange={handleKeyPassageChange}>
            {currentSphere ? (
              getKeyPassages(currentSphere).map((kp, index) => {
                const book = kp.ref.substring(0, 3)
                const isAvailable =
                  AvailableContent.content[language][version][
                    book
                  ] &&
                  AvailableContent.content[language][version][
                    book
                  ].segments.length > 1
                    ? false
                    : true
                return (
                  <MenuItem
                    key={index}
                    style={
                      isAvailable ? { color: "grey", fontStyle: "italic" } : {  }
                    }
                    value={kp.id.split("-")[1]}
                  >
                    <div className={classes.checkMarkDiv}>
                      <CheckMark
                        language={language}
                        version={version}
                        id={kp.id}
                        empty
                        disable
                      />
                    </div>
                    <div style={{maxWidth: '65vw'}}>
                      {`#${kp.number}: ${getTranslation(
                        translations,
                        language,
                        "KeyPassages",
                        // kp.id.substring(0, 3),
                        KeyPassages[kp.id].title
                      )}`}
                    </div>
                  </MenuItem>
                )
              })
            ) : (
              <MenuItem value="">Select Sphere First</MenuItem>
            )}
          </Select>
        </FormControl>
      )}
    </form>
  )
}
